module.exports = __webpack_public_path__ + "img/组 1.bbfc781d.png";